import { defineStore } from "pinia";
import EducacionService from "@/service/EducacionService";
export const useEdutionStore = defineStore("storeEducacion", {
  state: () => {
    return {
      educationQuintiles: [],
      educationQuintilesByYear: [],
    };
  },
  actions: {
    setToken(token, user) {
      this.token = token;
      this.user = user;
    },
    async getEntrada() {
      const eduService =new EducacionService();
      var respones = await eduService.getEntrada();
      console.log(respones);
    },

    async getTotalCantidad(){
      const eduService =new EducacionService();
      return await eduService.getTotalCantidad();
      
    }
  },
});
